// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type ExecutionRequest,
  ExecutionRequestFromJSON,
  ExecutionRequestToJSON,
} from "../models/ExecutionRequest";
import {
  type PageProcessRead,
  PageProcessReadFromJSON,
  PageProcessReadToJSON,
} from "../models/PageProcessRead";
import {
  type ProcessExecutionResponse,
  ProcessExecutionResponseFromJSON,
  ProcessExecutionResponseToJSON,
} from "../models/ProcessExecutionResponse";
import { type ProcessRead, ProcessReadFromJSON, ProcessReadToJSON } from "../models/ProcessRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface ProcessExecutionRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  processId: string;
  /**
   *
   */
  executionRequest: ExecutionRequest;
}

export interface ProcessListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: ProcessListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Tag to filter on
   */
  tag?: string | null;
  /**
   * Filter by name (case-insensitive substring match)
   */
  name?: string | null;
}

export interface ProcessRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  processId: string;
}

/**
 *
 */
export class ProcessesApi extends runtime.BaseAPI {
  /**
   * Creates request options for processExecution without sending the request
   */
  async processExecutionRequestOpts(
    requestParameters: ProcessExecutionRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling processExecution().'
      );
    }

    if (requestParameters["processId"] == null) {
      throw new runtime.RequiredError(
        "processId",
        'Required parameter "processId" was null or undefined when calling processExecution().'
      );
    }

    if (requestParameters["executionRequest"] == null) {
      throw new runtime.RequiredError(
        "executionRequest",
        'Required parameter "executionRequest" was null or undefined when calling processExecution().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/processes/{process_id}/execution`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{process_id}",
      encodeURIComponent(String(requestParameters["processId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExecutionRequestToJSON(requestParameters["executionRequest"]),
    };
  }

  /**
   * Provide relevant details for the process execution.
   * Execute a process by creating a new job.
   */
  async processExecutionRaw(
    requestParameters: ProcessExecutionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProcessExecutionResponse>> {
    const requestOptions = await this.processExecutionRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProcessExecutionResponseFromJSON(jsonValue)
    );
  }

  /**
   * Provide relevant details for the process execution.
   * Execute a process by creating a new job.
   */
  async processExecution(
    requestParameters: ProcessExecutionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProcessExecutionResponse> {
    const response = await this.processExecutionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for processList without sending the request
   */
  async processListRequestOpts(
    requestParameters: ProcessListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling processList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["tag"] != null) {
      queryParameters["tag"] = requestParameters["tag"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/processes`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of processes.
   * list processes
   */
  async processListRaw(
    requestParameters: ProcessListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageProcessRead>> {
    const requestOptions = await this.processListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageProcessReadFromJSON(jsonValue));
  }

  /**
   * Return a list of processes.
   * list processes
   */
  async processList(
    requestParameters: ProcessListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageProcessRead> {
    const response = await this.processListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for processRetrieve without sending the request
   */
  async processRetrieveRequestOpts(
    requestParameters: ProcessRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling processRetrieve().'
      );
    }

    if (requestParameters["processId"] == null) {
      throw new runtime.RequiredError(
        "processId",
        'Required parameter "processId" was null or undefined when calling processRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/processes/{process_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{process_id}",
      encodeURIComponent(String(requestParameters["processId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of a process.
   * show process
   */
  async processRetrieveRaw(
    requestParameters: ProcessRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProcessRead>> {
    const requestOptions = await this.processRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProcessReadFromJSON(jsonValue));
  }

  /**
   * Return detailed information of a process.
   * show process
   */
  async processRetrieve(
    requestParameters: ProcessRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProcessRead> {
    const response = await this.processRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ProcessListOrderByEnum = {
  RanaId: "rana_id",
  Name: "name",
  Name2: "-name",
  CreatedAt: "-created_at",
  UpdatedAt: "-updated_at",
} as const;
export type ProcessListOrderByEnum =
  (typeof ProcessListOrderByEnum)[keyof typeof ProcessListOrderByEnum];
